"use client";

import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import "./ImageSwiperSection.scss";

import "swiper/css";

const videoExtensions = [".mp4", ".webm", ".ogg"];

const ImageSwiperSection = ({
  title,
  description,
  items = [],
  sectionClass = "",
  titleClass = "",
  descriptionClass = "",
}) => {
  const isVideoFile = (src = "") => {
    const mediaSrc = typeof src === "string" ? src : src?.src || "";
    return videoExtensions.some((ext) => mediaSrc.toLowerCase().endsWith(ext));
  };

  return (
    <section className={`reusable-image-swiper-section ${sectionClass}`}>
      <Container>
        <Row className="top-wrapper align-items-start">
          <Col lg={6}>
            <h2 className={`section-title ${titleClass}`}>{title}</h2>
          </Col>

          <Col lg={4} className="ms-auto">
            <p className={`section-description ${descriptionClass}`}>
              {description}
            </p>
          </Col>
        </Row>
      </Container>

      <div className="fullwidth-swiper-wrapper">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          slidesPerView="auto"
          spaceBetween={30}
          speed={3500}
          allowTouchMove={false}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            320: { spaceBetween: 14 },
            576: { spaceBetween: 16 },
            768: { spaceBetween: 20 },
            1200: { spaceBetween: 24 },
            1400: { spaceBetween: 30 },
          }}
        >
          {items.map((item, index) => {
            const media = item.media || item.image;
            const isVideo = item.type === "video" || isVideoFile(media);

            return (
              <SwiperSlide key={`${item.title}-${index}`}>
                <div className="swiper-card">
                  <div className="feature-image">
                    {isVideo ? (
                      <video
                        className="feature-video"
                        src={media}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    ) : (
                      <Image
                        src={media}
                        alt={item.title || "Feature image"}
                        fill
                        sizes="(max-width: 576px) 90vw, (max-width: 991px) 45vw, 380px"
                      />
                    )}

                    <div className="image-overlay" />

                    <div className="card-content">
                      <h5 className="customer-title">{item.title}</h5>
                      <p className="customer-description">{item.description}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default ImageSwiperSection;
